<template>
  <signup-page />

</template>

<script>
import SignupPage from "@/components/Auth/Signup/index";
export default {
  components: {
    SignupPage,
  },
  mounted(){
    alert("UPdated")
  }
};
</script>

<style></style>
